export const addToCartButtonComponent = {
  key: 'addToCartButtonComponent',
  name: 'Add To Cart Button Dept-Component',
  siteIdentifier: 'global',

  addToCartLabel: 'Add to Cart',
};
